<template>
  <div class="app">
    <span class="posit left">
      <img src="../../static/img/bg-left.png" alt />
    </span>
    <span class="posit right">
      <img src="../../static/img/bg-right.png" alt />
    </span>
    <main>
      <div class="main-container">
        <div class="fixed" v-if="show1">请点击右上角选择“浏览器中打开”</div>
        <div class="logoFarm">
          <div class="logo">
            <img
              v-if="getList.customerImg"
              :src="getList.qnyInAddress + '/' + getList.customerImg"
              alt
            />
          </div>
          <div class="bg"></div>
          <div class="qrcode" id="qrcode" ref="qrcode"></div>
        </div>
        <div class="imgfarm">
          <div v-if="!show2">
            <div class="img" v-if="type == 1">
              <img src="../../static/img/Android.png" style="width='2rem'" alt />
            </div>
            <div class="img_apple" v-else>
              <img src="../../static/img/Apple.png" style="width='2rem'" alt />
            </div>
          </div>

          <div class="title">
            <span>{{ getList.customerName }}</span>
          </div>
        </div>
        <div class="PC" v-if="show4">扫描二维码下载或用手机浏览器输入这个网址: {{ this.path }}</div>
        <div class="WQ" v-if="show1">微信/QQ 内无法下载应用</div>
        <div class="WQ" v-if="show1 && show5">
          <div class="bd">
            <img src="../../static/img/jhglsm.png" style="width='120px'" alt />
            <p>微信扫一扫，开始暴富之路</p>
          </div>
        </div>
        <div v-else>
          <div v-if="!show4 && show5">
            <div class="bd">
              <img src="../../static/img/jhglsm.png" style="width='120px'" alt />
              <p>微信扫一扫，开始暴富之路</p>
            </div>
          </div>
          <div v-else>
            <div v-if="!show2" class="bd">
              <p>
                {{ getList.appVersion }}
                <span
                  v-if="getList.appBuildVersion"
                >(Build {{ getList.appBuildVersion }})</span>
                - {{ getList.appSize }}MB
              </p>
              <p v-if="getList.createTime">
                更新于
                {{
                getList.createTime.substring(0, 4) +
                '-' +
                getList.createTime.substring(4, 6) +
                '-' +
                getList.createTime.substring(6, 8) +
                ' ' +
                getList.createTime.substring(8, 10) +
                ':' +
                getList.createTime.substring(10, 12) +
                ':' +
                getList.createTime.substring(12, 14)
                }}
              </p>
            </div>
          </div>
          <div class="btn" v-if="!isAppkey">
            <a
              :href="getList.thirdUrl"
              target="_blank"
              v-if="getList.thirdState == 0 && show && type == 0"
            >下载安装</a>
            <a :href="getList.appUrl" @click="jump" v-else-if="show">下载安装</a>
            <button v-if="show3" disabled>安装中</button>
          </div>
          <div class="btn" v-else>
            <a id="downloadButton" @click="jump" v-if="show">下载安装</a>
            <button v-if="show3" disabled>安装中</button>
          </div>
          <div v-if="type == 0 && getList.appQuickUrl" class="btn">
            <a :href="getList.appQuickUrl">极速安装</a>
          </div>
          <div class="food_btn" v-if="type == 0">
            <span @click="go_course">详细安装教程</span>
            <a class="food_btn_a" href="../../static/embedded.mobileprovision">安装完毕，去信任</a>
          </div>
          <div v-if="type == 0 && getList.appQuickUrl" class="notice">
            <p>温馨提醒：</p>极速安装：IOS用户手机系统版本在12.2版本及以上，将会出现
            <span style="color:#FF0000;">&lt;已下载描述文件&gt; ,</span>需要您点击
            <span style="color:#169BD5;">&lt;安装完毕，去信任&gt;</span>找到本应用，点击安装，返回桌面即可看见本应用已经安装完成。
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import localPackageConfig from "../assets/localPackageConfig";
import $ from "jquery";
export default {
  name: "index",
  data() {
    return {
      isLocalPackage: false,
      localPackageName: "",
      show2: false,
      show: true,
      show1: false,
      show3: false,
      show4: true,
      show5: false,
      getList: [],
      uAI: navigator.userAgent,
      WQ: navigator.userAgent.toLowerCase(),
      ip: SETTING.apiHost,
      type: 1,
      http: window.location.href,
      applePath: "itms-services://?action=download-manifest&url=" + SETTING.apiHost,
      path: window.location.href,
      isAppkey: false
    };
  },
  watch: {
    $route(to, from) {
      this._getQart();
      this.getInfo();
    }
  },
  async created() {
    this.isLocalPackageConfig();
    await this.getInfo();
    this._getQart();
    this.QQ();
  },
  mounted() {},
  methods: {
    // 本地写死包名213213213213
    async isLocalPackageConfig() {
      let host = window.location.host;
      Object.keys(localPackageConfig).map(x => {
        if (~host.indexOf(x)) {
          this.isLocalPackage = true;
          this.localPackageName = localPackageConfig[x];
        }
      });
    },
    async _getQart() {
      document.getElementById("qrcode").innerHTML = "";
      var qrcode = new QRCode(document.getElementById("qrcode"), {
        width: 100, //设置宽高
        height: 100
      });

      qrcode.makeCode(this.http);
    },
    async getInfo() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.show4 = false;
        if (this.uAI.indexOf("Android") > -1 || this.uAI.indexOf("Linux") > -1) {
          this.type = 1;
        } else if (this.uAI.indexOf("iPhone") > -1) {
          this.type = 0;
        }
      } else {
        this.show = false;
        this.show2 = true;
        this.show5 = false;
      }
      let packageName = this.isLocalPackage ? this.localPackageName : this.$route.params.name;
      let res = await this.$http("/app/download/" + packageName, {
        body: {
          appType: this.type
        }
      });
      if (res.returnCode == "0000") {
        this.getList = res.returnMap;
        if (this.appHasChanged != 1 && this.type == 0) {
          this.getList.appUrl = this.applePath + this.getList.appUrl;
        }
        if (this.getList.appSubName == "com.xinJinHui.Lottery") {
          this.show5 = true;
        }
        if (this.getList.appkey) {
          this.isAppkey = true;
          this.getApp(this.getList.appkey);
        } else {
          this.isAppkey = false;
        }
      } else {
      }
    },
    go_course() {
      this.$router.push("/detail/course");
    },
    async jump() {
      this.show = false;
      this.show3 = true;
      this.timeOut = setTimeout(() => {
        this.show = true;
        this.show3 = false;
      }, 10000);
    },
    async QQ() {
      var UA = navigator.userAgent,
        isAndroid = /android|adr/gi.test(UA),
        isIos = /iphone|ipod|ipad/gi.test(UA) && !isAndroid,
        isWeixin = /MicroMessenger/gi.test(UA),
        isQQ = /QQ\/\d/gi.test(UA),
        isUnabledInstall = isWeixin || isQQ,
        isMobile = isAndroid || isIos;
      if (isUnabledInstall) {
        this.show1 = true;
        return;
      }
    },
    // app传值到第三方下载
    async getApp(Key) {
      var data = OpenInstall.parseUrlParams(); //openinstall.js中提供的工具函数，解析url中的所有查询参数
      let openInstall = new OpenInstall(
        {
          /*appKey必选参数，openinstall平台为每个应用分配的ID*/
          appKey: Key,
          /*可选参数，自定义android平台的apk下载文件名；个别andriod浏览器下载时，中文文件名显示乱码，请慎用中文文件名！*/
          // apkFileName : 'com.fm.openinstalldemo-v2.2.0.apk',
          /*可选参数，是否优先考虑拉起app，以牺牲下载体验为代价*/
          preferWakeup: true,
          /*自定义遮罩的html*/
          //mask:function(){
          //  return "<div id='openinstall_shadow' style='position:fixed;left:0;top:0;background:rgba(0,255,0,0.5);filter:alpha(opacity=50);width:100%;height:100%;z-index:10000;'></div>"
          //},
          /*openinstall初始化完成的回调函数，可选*/
          onready: function() {
            let m = this;
            let button = document.getElementById("downloadButton");
            button.style.visibility = "visible";
            /*在app已安装的情况尝试拉起app*/
            m.schemeWakeup();
            /*用户点击某个按钮时(假定按钮id为downloadButton)，安装app*/
            button.onclick = function() {
              m.wakeupOrInstall();
              return false;
            };
          }
        },
        data
      );
    }
  }
};
</script>

<style lang="css" scoped>
.posit {
  position: absolute;
  width: 12%;
  top: 0;
  max-width: 312px;
  transition: all 0.5s;
  z-index: 0;
}

.posit img {
  width: 100%;
}
.left {
  left: 0;
}
.right {
  right: 0;
}
main {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  left: 0;
  right: 0;
}
.main-container {
  text-align: center;
  position: relative;
  left: 0;
  right: 0;
}
.logoFarm {
  width: 300px;
  height: 300px;
  position: relative;
  margin: 2.5rem auto 0;
}
.bg {
  background: #eff2f2;
  position: absolute;
  width: 180px;
  height: 240px;
  left: 50%;
  top: 50%;
  margin-top: -120px;
  margin-left: -90px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  z-index: 1;
}
.qrcode {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100px;
  height: 100px;
  border-radius: 20px;
  padding: 20px;
  background: #eff2f2;
  z-index: 2;
  transition: 0.3s;
  -webkit-transition: 0.3s;
  cursor: pointer;
}
.qrcode:hover {
  transform: scale(1.5);
  -webkit-transform: scale(1.5);
  box-shadow: 0 0 5px grey;
}
.qrcode img {
  border-radius: 20px;
}
.logo {
  padding: 10px;
  border-radius: 20px;
  position: absolute;
  left: 0;
  top: 0;
  width: 120px;
  height: 120px;
  z-index: 2;
  background: white;
}
.logo img {
  display: inline-block;
  width: 120px;
  height: 120px;
  border-radius: 20px;
}
.img {
  width: 4rem;
  height: 4rem;
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -2rem;
  left: 25rem;
}
.img_apple {
  width: 4rem;
  height: 4rem;
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -2rem;
  left: 25rem;
}
.img > img {
  background-size: 100% 100%;
  width: 2.5rem;
}
.img_apple > img {
  background-size: 100% 100%;
  width: 2.5rem;
}
.imgfarm {
  position: relative;
  width: 100%;
  margin: 0 auto;
}
.title {
  font-size: 0.4rem;
  display: inline-block;
  height: 1rem;
  width: 30%;
  border-bottom: 2px solid lightgray;
  margin: 1rem auto 0.8rem;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 5rem;
}

.WQ {
  color: rgb(50, 178, 167);
}
p {
  color: #999;
  font-size: 1.2rem;
  white-space: nowrap;
}
button {
  width: 15rem;
  height: 3rem;
  background-color: rgb(50, 178, 167);
  border: none;
  border-radius: 5rem;
  font-size: 1rem;
  margin-top: 1rem;
}
button {
  text-decoration: none;
  color: white;
  outline: none;
  cursor: pointer;
}
a {
  display: inline-block;
  width: 15rem;
  height: 3rem;
  background-color: rgb(50, 178, 167);
  border: none;
  border-radius: 5rem;
  font-size: 1rem;
  margin-top: 1rem;
  color: white;
  text-decoration: none;
  line-height: 3rem;
}
.fixed {
  display: block;
  position: absolute;
  top: 5px;
  right: 20px;
  font-size: 0.8rem;
  color: white;
  background-color: rgb(50, 178, 167);
  width: 5rem;
  text-align: center;
  padding: 0.7rem;
  border-radius: 0.7rem;
  z-index: 99;
}
.PC {
  font-size: 0.25rem;
}
.notice {
  font-size: 0.8rem;
  text-align: left;
  color: #ff9900;
  padding: 0 2.8rem;
}
.notice p {
  font-size: 1rem;
  color: #ff9900;
  margin-bottom: 0;
}
@media screen and (max-width: 880px) {
  .posit {
    width: 20%;
  }
  .main-container {
    text-align: center;
    position: relative;
    left: 0;
    right: 0;
  }
  .logoFarm {
    padding: 0;
    width: 250px;
    height: 200px;
    margin: 0 auto;
  }
  .qrcode {
    position: absolute;
    right: 0;
    bottom: 0;
    margin: 0;
    display: none;
  }
  .logo {
    left: 50%;
    margin-left: -60px;
    top: inherit;
    padding: 0;
    bottom: 10px;
  }
  .bg {
    display: none;
  }
  .img {
    width: 3.5rem;
    height: 3.5rem;
    position: absolute;
    top: 50%;
    margin-top: -1.5rem;
    left: 4.6rem;
    top: 3.8rem;
  }
  .img_apple {
    width: 3.5rem;
    height: 3.5rem;
    position: absolute;
    top: 50%;
    margin-top: -1.5rem;
    left: 4rem;
    top: 3.6rem;
  }
  .imgfarm {
    position: relative;
    margin: 0 auto !important;
  }
  .img > img {
    background-size: 100% 100%;
    width: 2rem;
  }
  .img_apple > img {
    background-size: 100% 100%;
    width: 2rem;
  }
  .title {
    text-align: center;
    font-size: 1.5rem;
    display: inline-block;
    height: 5rem;
    width: 20rem;
    border-bottom: 2px solid lightgray;
    position: relative;
    margin: 1rem;
  }
  p {
    color: #999;
    font-size: 0.8rem;
    white-space: nowrap;
  }
  .food_btn {
    display: flex;
    justify-content: space-around;
    color: #5299d6;
    margin-top: 1.5rem;
    font-size: 14px;
  }
  .food_btn_a {
    display: inline-block;
    width: auto;
    height: auto;
    background-color: #fff !important;
    color: #5299d6 !important;
    font-size: 14px !important;
    font-size: 1rem;
    margin-top: auto;
    text-decoration: none;
    line-height: initial;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/warp.vue